<fieldset>
    <legend [class.pull-left]="description !== ''">{{ field }}:</legend>
    <span class="clearfix" *ngIf="description !== ''">
        {{ description }}
    </span>
    <div class="range-slider-container">
        <input id="minValue" type="number" aria-label="Minimum Value" [min]="min" [max]="maxValue" [step]="step" [(ngModel)]="minValue" *ngIf="mode === 'multiple'" />
        <div class="range-slider">
            <input #sliderMin type="range" aria-label="Minimum Value" [min]="min" [max]="max" [step]="step" [(ngModel)]="minValue" *ngIf="mode === 'multiple'" />
            <div #slider></div>
            <input #sliderMax type="range" [attr.aria-label]="mode === 'single' ? 'Value' : 'Maximum Value'"[min]="min" [max]="max" [step]="step" [(ngModel)]="maxValue" />
        </div>
        <input id="maxValue" type="number" [attr.aria-label]="mode === 'single' ? 'Value' : 'Maximum Value'" [min]="minValue" [max]="max" [step]="step" [(ngModel)]="maxValue" />
    </div>
</fieldset>
